var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',{attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"addbutton":true,"default_limit":'1000',"default_sort":'name',"default_sort_typ":'ASC',"extension":_vm.extension}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }